import { v4 as uuidv4 } from 'uuid';

export function SubmenuAccordion(props, childrenComponents = [], blocks = []) {
	return {
		componentName: 'SubmenuAccordion',
		componentId: uuidv4(),
		props,
		childrenComponents,
		blocks,
	};
}
